const LABEL_STYLE = {
  verified: "text-green-400 border-green-700/60 bg-green-950/30",
  observed: "text-blue-400 border-blue-700/60 bg-blue-950/30",
  inferred: "text-amber-400 border-amber-700/60 bg-amber-950/30",
  unknown: "text-purple-400 border-purple-700/60 bg-purple-950/30",
};

export const EvidenceBadge = ({ label, confidence }) => {
  if (!label) return null;
  const k = String(label).toLowerCase().split(/[\s/]/)[0];
  return (
    <span data-testid="evidence-badge" className={`inline-flex flex-none items-center gap-1 border px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-widest ${LABEL_STYLE[k] || LABEL_STYLE.unknown}`}>
      {label}{typeof confidence === "number" && <span className="opacity-70">· {confidence}%</span>}
    </span>
  );
};

export const Section = ({ title, children, testid, className = "" }) => (
  <section data-testid={testid} className={`rea-panel rea-brackets p-5 sm:p-6 ${className}`}>
    <h3 className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-red-500">{title}</h3>
    {children}
  </section>
);

export const Findings = ({ items, empty = "No evidence available for this category." }) => {
  if (!items?.length) return <p className="text-sm text-neutral-500">{empty}</p>;
  return (
    <ul className="space-y-2.5">
      {items.map((f, i) => (
        <li key={i} className="flex items-start justify-between gap-3 border-b border-[#1a1a1a] pb-2.5 last:border-0 last:pb-0">
          <span className="text-sm leading-relaxed text-neutral-200">{typeof f === "string" ? f : f.text}</span>
          {typeof f !== "string" && <EvidenceBadge label={f.label} confidence={f.confidence} />}
        </li>
      ))}
    </ul>
  );
};

export const Bullets = ({ items }) => (
  <ul className="space-y-2">
    {(items || []).map((x, i) => (
      <li key={i} className="flex gap-3 text-sm leading-relaxed text-neutral-200"><span className="font-mono text-xs text-red-600">{String(i + 1).padStart(2, "0")}</span>{x}</li>
    ))}
  </ul>
);

export const TechList = ({ items }) => {
  if (!items?.length) return <p className="text-sm text-neutral-500">Nothing detectable from client-side evidence.</p>;
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {items.map((t, i) => (
        <div key={i} className="border border-[#222] bg-[#0a0a0a] p-3">
          <div className="flex items-start justify-between gap-2">
            <p className="font-mono text-sm text-white">{t.name}</p><EvidenceBadge label={t.label} confidence={t.confidence} />
          </div>
          <p className="mt-0.5 font-mono text-[10px] uppercase tracking-widest text-[#d4af37]">{t.category}</p>
          {t.evidence && <p className="mt-1.5 text-xs text-neutral-400">{t.evidence}</p>}
        </div>
      ))}
    </div>
  );
};

export const Prose = ({ children }) => <p className="text-base leading-relaxed text-neutral-300">{children}</p>;

export const KV = ({ k, v }) => (
  <div className="flex justify-between gap-4 border-b border-[#1a1a1a] py-2 last:border-0">
    <span className="rea-label">{k}</span><span className="break-all text-right font-mono text-xs text-neutral-200">{v ?? "—"}</span>
  </div>
);
